import { DocumentList, Flex, Loader, Text } from '@components';
import { useUserDocumentsQuery } from '@features/api/userSlice';
import { useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Container } from './UserDocuments.styles';

const FALLBACK_THUMBNAIL_URL =
  'https://static-product-images.s3.eu-central-1.amazonaws.com/user_document_thumbnail_placeholder.jpg';

const UserDocuments: React.FC = () => {
  const theme = useTheme();
  const { data: documents, isFetching, isLoading } = useUserDocumentsQuery();
  const signedDocuments = documents?.filter((x) => x.signed) ?? [];

  return (
    <Container>
      <Loader isLoading={isFetching || isLoading} />
      {signedDocuments && signedDocuments.length > 0 ? (
        <DocumentList
          title=''
          documents={signedDocuments.map((x) => ({
            name: x.documentName ?? x.productName,
            thumbnailLink: x.thumbnailLink ?? FALLBACK_THUMBNAIL_URL,
            downloadLink: x.url,
            displayName: x.displayName,
          }))}
        />
      ) : (
        <Flex flex={1} justifyContent='center' alignItems='center'>
          <Text
            variant='h6'
            fontWeight='fontWeightMedium'
            sx={{ color: theme.palette.grey.A100 }}
          >
            <FormattedMessage id='userDocuments.signedDocumentsWillAppearHere' />
          </Text>
        </Flex>
      )}
    </Container>
  );
};

export default UserDocuments;
